// 滚动到指定元素位置
const scrollToTarget = (target, smoothScroll) => {
  let mql = window.matchMedia('(max-width: 767px)');
  let isMobile = mql.matches;
  let fixedHeaderHeight = 0;
  let distance = window.scrollY + target.getBoundingClientRect().top;
  const fixHeaderNavigation = document.querySelector('.header-sticky');
  const ul = document.querySelector('#pProductOverviewMenu ul');
  const catalog = ul ? getComputedStyle(ul).height : '0px';
  if (fixHeaderNavigation) {
    const fixHeaderNavigationHeight = getComputedStyle(fixHeaderNavigation).height;
    fixedHeaderHeight = Number(fixHeaderNavigationHeight.replace('px', '')) + Number(catalog.replace('px', ''));
  }
  const headerCountdown = document.querySelector('.shopify-section-group-header-group.countdown-section');
  if (headerCountdown && !headerCountdown.classList.contains('hide')) {
    const headerCountDownHeight = getComputedStyle(headerCountdown).height;
    fixedHeaderHeight = fixedHeaderHeight + Number(headerCountDownHeight.replace('px', ''));
  }

  savedFixedHeaderHeight = fixedHeaderHeight;

  if (smoothScroll) {
    window.scrollTo({
      top: distance - fixedHeaderHeight + 1,
      left: 0,
      behavior: 'smooth'
    })
  } else {
    window.scrollTo(0, distance - fixedHeaderHeight + 1);
  }
}

// 获取 url 里 ? 后的指定 key 的值
function getURLParameter(key) {
  return (
    decodeURIComponent(
      (new RegExp("[?|&]" + key + "=([^&;]+?)(&|#|;|$)", "i").exec(
        location.search
      ) || [, ""])[1].replace(/\+/g, "%20")
    ) || null
  );
}

// 打开页面，然后滚动到指定 ID
function getElement(id) {
  const target = document.getElementById(id);
  if (target) {
    scrollToTarget(target);
  } else {
    requestAnimationFrame(() => getElement(id)); // 若元素未找到，继续尝试
  }
}
const openAndScroll = () => {
  const targetId = getURLParameter('id');
  if (targetId) {
    console.log('targetId: ', targetId);
    getElement(targetId);
  }
};
openAndScroll();